import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import {base_url} from '../_common'
import {buildIndex, mockRequests} from './_utils'
import {ResponseError} from './_response'
import middlewares from './_middlewares'
import data from './data/items'
import {increase_counter, registered_sections} from './updates'

// =============================================================
// mock axios requests

const path = `${base_url}/items`;
let mockAdapter;

export function register_mock() {
  registered_sections['items'] = true;
  mockAdapter = new MockAdapter(axios);

  mockRequests({
    mockAdapter,
    delay: 500,
    middlewares: middlewares.basic,
    requests: [
      ['post', path, ({data}) => store(data.item)],
      ['put', path+'/:id', ({route, data}) => update(route.id, data.item)],
      ['delete', path+'/:id', ({route}) => destroy(route.id)],
    ]
  });

  // pass through other requests
  mockAdapter.onAny().passThrough();
}

// =============================================================
// data

const items = data.items;

let inx;

// =============================================================
// controller helper methods

function rebuild(counters = true) {
  inx = buildIndex(items);
  counters && increase_counter('items');
}
rebuild(false);

export function get_data() {
  return items;
}

// =============================================================
// controller CRUD methods

export function store(item) {
  item.id = data.new_id('items');

  // validation example
  if (!item.description) {
    throw new ResponseError(422, {description: ['required']});
  }
  if (item.description.length < 3) {
    throw new ResponseError(422, {description: ['min__string@3']});
  }

  items.push(item);
  rebuild();
  return {id: item.id};
}

export function update(id, item) {
  if (inx[id] === undefined) {
    throw new ResponseError(404, {_: ['not_found@Item']});
  }

  // validation example
  if (id == 14 && item.serialized != items[inx[id]].serialized) {
    throw new ResponseError(422, {serialized: ['relation_edit']});
  }

  // server error example
  if (item.description.length < 3) {
    // eslint-disable-next-line
    x = 0;
  }

  item = {
    ...items[inx[id]],
    ...item
  }
  
  items.splice(inx[id], 1, item);
  rebuild();
}

export function destroy(id) {
  if (inx[id] === undefined) {
    throw new ResponseError(404, {_: ['not_found@Item']});
  }

  // validation example
  if (id == 14) {
    throw new ResponseError(422, {_: ['relation_delete']});
  }

  // permission example
  if (id < 5) {
    throw new ResponseError(403, {_: ['unauthorized']});
  }

  // server error example
  if (items[inx[id]].serialized) {
    // eslint-disable-next-line
    x = 0;
  }

  items.splice(inx[id], 1);
  rebuild();
}
